module.exports = __webpack_public_path__ + "img/kr-product-card3-step1.5148a39.png";